export default function(number, sign = false, count = 0, decimal = ',', thousand = ' ') {
  let ret = '';

  if (typeof number === 'string') {
    number = number.replace(',', '.');
    number = parseFloat(number);
  }

  if (sign) {
    if (number > 0) {
      ret += '+';
    }
    else {
      ret += '-';
      number = Math.abs(number);
    }
  }

  let s = number < 0 ? '-' : '';
  let i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(count), 10));
  let j = i.length;
  j = j > 3 ? j % 3 : 0;

  let final = s + (j ? i.substr(0, j) + thousand : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousand) + (count ? decimal + Math.abs(number - i).toFixed(count).slice(2) : '');

  return `${ret} ${final}`;
}
